import { FC } from 'react';
import { Box, Flex, Image } from '@chakra-ui/react';

import SunshineIcon from 'components/_core/SunshineIcon';
import Text from 'components/_core/Text';
import RebrandedPrice from 'components/Price/rebranded';
import amountWithMinorCurrency from 'features/Onboarding/modules/PricingPlan/helpers/amountWithMinorCurrency';

interface BasketItemProps {
  boldLabel?: boolean;
  imgSrc?: string;
  initialPrice?: number;
  label: string;
  price: number;
  showExcludingVat?: boolean;
  showIncludingVat?: boolean;
  offer?: string;
}

export const BasketItem: FC<BasketItemProps> = ({
  boldLabel,
  imgSrc,
  initialPrice,
  label,
  offer,
  price,
  showExcludingVat,
  showIncludingVat,
}) => (
  <Flex
    _last={{
      marginBottom: 0,
    }}
    alignItems="flex-start"
    marginBottom="space-24"
    width="100%"
  >
    <Flex flexDirection="column">
      <Flex alignItems="center">
        {imgSrc ? (
          <Image marginRight="space-16" src={imgSrc} width="34px" />
        ) : null}
        <Text
          fontWeight={boldLabel ? 500 : 400}
          variant={boldLabel ? 'primary' : 'secondary'}
        >
          {label}
        </Text>
      </Flex>
      {offer ? (
        <Flex marginTop="space-16">
          <SunshineIcon marginRight="space-4" name="gift" size="icon-16" />
          <Text fontSize="font-13" variant="secondary">
            {offer}
          </Text>
        </Flex>
      ) : null}
    </Flex>
    <Box marginLeft="auto">
      <RebrandedPrice
        fontSize="font-15"
        showExcludingVat={showExcludingVat}
        showIncludingVat={showIncludingVat}
        textAlign="right"
        value={amountWithMinorCurrency(price)}
        withoutCents={Number.isInteger(price / 100)}
      />
      {initialPrice ? (
        <RebrandedPrice
          color="grey.600"
          fontSize="font-13"
          showExcludingVat={showExcludingVat}
          showIncludingVat={showIncludingVat}
          textAlign="right"
          textDecoration="line-through"
          value={amountWithMinorCurrency(initialPrice)}
          withoutCents={Number.isInteger(initialPrice / 100)}
        />
      ) : null}
    </Box>
  </Flex>
);
